module.exports = __webpack_public_path__ + "static/images/biffy_plutonium_splash.f14e206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biffy_plutonium_splash.jpg
// module id = U8Q/
// module chunks = 1